import React from "react";
import { connect } from "react-redux";

import * as actions from "../../../store/actions";

import { getOnboardingPath } from "../../../constants";
import { PROFILE_CARD } from "../../../constants";

import Button from "../../../components/formElements/button/Button";

import Gretting from "../../../utils/gretting";
import { getUserData } from "../../../utils/localStorage";

const CreateProfile = ({ history, logout }) => {
  const userData = getUserData();
  console.log(userData, "userData");

  return (
    <div className="container text-center" style={{ maxWidth: 550 }}>
      <p className="header" style={{ fontSize: 20 }}>
        {Gretting()},
        <br />
        <span className="change-primary-color">
          {userData.firstName} {userData.lastName}
        </span>
      </p>
      <img src={PROFILE_CARD} alt="" />
      <p className="change-primary-color">Let’s create your profile</p>
      <p>
        Your profile makes you visible to the hundreds of patients searching on
        UrgiDoctor and manage your practice on the go.
      </p>
      <Button
        className="w-75 mb-3"
        label="Create Profile"
        onClick={() => history.push(getOnboardingPath("/step1"))}
      />
      <br />
      <div className="link" onClick={() => logout()}>
        Sign out
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
});

export default connect(undefined, mapDispatchToProps)(CreateProfile);
